"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18nifyLite = require("@ifly/react-i18nify-lite");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Base = _reactI18nifyLite.Translate.__proto__;
/**
 * Renders a text React.Fragment message for the given key and current locale.
 * 
 * The resource key is passed as the `$` property.
 *
 * Adding the `iFlyUpperCase` prop will return the entire string as uppercase
 * except for the "i" in iFLY.
 *
 * If you need to transform the message supply a `fn` prop with a function that
 * takes a string parameter and returns a string.
 * 
 * Pass the `dangerousHTML` prop as `true` to emit messages that contain markup.
 * The result is wrapped a `<span>` tag.
 * 
 * Any additional properties are treated as replacements values for any tokens 
 * with the same name.
 */

var I18n =
/*#__PURE__*/
function (_Base) {
  _inherits(I18n, _Base);

  function I18n() {
    _classCallCheck(this, I18n);

    return _possibleConstructorReturn(this, _getPrototypeOf(I18n).apply(this, arguments));
  }

  _createClass(I18n, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          key = _this$props.$,
          iFlyUpperCase = _this$props.iFlyUpperCase,
          dangerousHTML = _this$props.dangerousHTML,
          fn = _this$props.fn,
          replacements = _objectWithoutProperties(_this$props, ["$", "iFlyUpperCase", "dangerousHTML", "fn"]),
          msg = _reactI18nifyLite.I18n.t(key, replacements);

      if (iFlyUpperCase) msg = msg.toUpperCase().replace(/\bIFLY\b/, 'iFLY');
      if (fn) msg = fn(msg);
      return dangerousHTML ? _react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: msg
        }
      }) : _react["default"].createElement(_react["default"].Fragment, null, msg);
    }
  }]);

  return I18n;
}(Base);

exports["default"] = I18n;
I18n.propTypes = {
  $: _propTypes["default"].string.isRequired,
  fn: _propTypes["default"].func,
  iFlyUpperCase: _propTypes["default"].bool,
  dangerousHTML: _propTypes["default"].bool
};